import { Component, inject } from "@angular/core";
import { Store } from "@ngxs/store";

import { fadeAnimation } from "./core/animations/route-transition.animation";
import { ConfigurationState } from "./core/configuration/state/configuration.state";
import { IdleService } from "./core/idle/idle.service";

import type { OnInit } from "@angular/core";

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
	animations: [fadeAnimation],
})
export class AppComponent implements OnInit {
	private store = inject(Store);
	private idleService = inject(IdleService);

	initialized$ = this.store.select(ConfigurationState.initialized);

	ngOnInit(): void {
		this.idleService.startRedirectOnIdle(["home"]);
	}
}
